export const GetViewType = (listType: starrez.DirectoryListTypeEnum): starrez.DirectoryViewType => {
    switch (listType) {
        case 'SAVED':
        case 'MY_SAVED':
        case 'SHARED_SAVED':
            return 'SAVED_LIST';
        case 'DYNAMIC':
        case 'MY_DYNAMIC':
        case 'SHARED_DYNAMIC':
            return 'DYNAMIC_LIST';

        default:
        case 'ALL':
            return 'NONE';
    }
};
